import { getSlaDueDate, slaStatuses } from "../FindingsUtils";
import React from "react";
import "./SLAStatus.scss";
import {
  slaTypes,
  TICKET_SLA,
} from "../../CustomizedDashboard/Widgets/SLA/SLAUtils";
import {
  getDaysFromNowDate,
  getRelativeTimeFromNow,
  Tooltip,
  isUndefinedOrNull,
} from "@SeemplicityDev/shared";

interface SLAStatusEntry {
  title?: string;
  icon?: string;
}

interface SLAStatusProps {
  sla_status?: string | null;
  remainingTime?: number | null;
  isLarge?: boolean;
  slaType?: string;
  /**
   * When true (default), hovering the remaining time reveals the due date.
   * Pass false when an ancestor already renders a tooltip (e.g. the findings
   * SlaStatus cell) — otherwise the tooltips nest.
   */
  showDueDateTooltip?: boolean;
}

const SLAStatus: React.FC<SLAStatusProps> = ({
  sla_status,
  remainingTime,
  isLarge = false,
  slaType = slaTypes.FINDING,
  showDueDateTooltip = true,
}) => {
  // slaStatuses / TICKET_SLA are still-JS objects keyed by SLA status string.
  const slaObj = (
    slaType === slaTypes.FINDING ? slaStatuses : TICKET_SLA
  ) as Record<string, SLAStatusEntry | undefined>;
  // getDaysFromNowDate expects a number; the JS original passed remainingTime
  // unconditionally even when undefined — its result is only rendered inside
  // the !isUndefinedOrNull(remainingTime) guard below.
  const dueDate = getDaysFromNowDate(remainingTime as number);
  // getRelativeTimeFromNow is typed for `string` in the shared .d.ts but
  // accepts the DateTime returned above at runtime (existing boundary mismatch
  // preserved from the JS implementation).
  const remainingTimeFromNow = getRelativeTimeFromNow(
    dueDate as unknown as string
  );

  return (
    !!sla_status && (
      <div className={`sla-status-wrap ${isLarge ? "is-large" : ""}`}>
        <span
          className={`sla-status-title ${(remainingTime ?? 0) < 0 || sla_status === "BROKEN_SLA" ? "past-due" : ""}`}
          data-testid={"sla-status-title"}
        >
          {slaObj?.[sla_status]?.title}
        </span>
        {!isUndefinedOrNull(remainingTime) && (
          <Tooltip
            content={
              showDueDateTooltip ? getSlaDueDate(remainingTime) : undefined
            }
          >
            <span className={"sla-status-remaining-time"}>
              {remainingTime === 0 ? (
                " (Today)"
              ) : (
                <span> ({remainingTimeFromNow})</span>
              )}
            </span>
          </Tooltip>
        )}
      </div>
    )
  );
};

export default SLAStatus;
